import { Modal, DatePicker, Button, notification } from 'antd'
import axios from 'axios'
import React, { useState } from 'react'
import BelirsizListModal from './BelirsizListModal'
import { CheckCircleTwoTone, SyncOutlined, WarningTwoTone } from '@ant-design/icons';
import baseUrl from '../../config';
import UretilemeyenListModal from './UretilemeyenListModal';
import { useTranslation } from 'react-i18next';

const dayjs = require('dayjs')

const BreakdownModal = ({
    modalOpen,
    setModalOpen
}) => {
    const { t } = useTranslation();
    const [dateStart, setDateStart] = useState("")
    const [dateEnd, setDateEnd] = useState("")
    const [allData, setAllData] = useState({
        machine: "",
        belirsiz: false
    })
    const [modalOpenBelirsiz, setModalOpenBelirsiz] = useState(false)
    const [modifiedDataBelirsiz, setModifiedDataBelirsiz] = useState([])
    const [modalOpenUretilemeyen, setModalOpenUretilemeyen] = useState(false)
    const [modifiedDataUretilemeyen, setModifiedDataUretilemeyen] = useState([])
    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement, value, icon) => {
        api.info({
            message: t('breakdownModal.title'),
            description: `${value}`,
            placement,
            icon: icon || <CheckCircleTwoTone twoToneColor="#52c41a" />,
        });
    };
    const handleBelirsiz = () => {
        setModalOpenBelirsiz(true)
        axios.get(`${baseUrl}/listOnGoingBD`)
            .then(res => setModifiedDataBelirsiz(res.data))
            .catch(err => console.log(err))
    }
    const uretilemeyenKod = () => {
        setModalOpenUretilemeyen(true)
        axios.get(`${baseUrl}/listpanelOut`)
            .then(res => setModifiedDataUretilemeyen(res.data))
            .catch(err => console.log(err))
    }
    const handleChange = (e, date, dateString) => {
        if (e.target.name === "belirsiz") {
            setAllData({ ...allData, [e.target.name]: e.target.checked })
            return
        }
        setAllData({ ...allData, [e.target.name]: e.target.value })
    }
    const onChangeStart = (date, dateString) => {
        setDateStart(dateString);
    };
    const onChangeEnd = (date, dateString, e) => {
        setDateEnd(dateString);
    };
    const disabledDate = (current) => {
        return current && current < dayjs().startOf('day');
    };
    const handleSubmit = (e) => {
        e.preventDefault()
        axios.post(`${baseUrl}/outOfOrderTime`, ({ belirsiz: allData.belirsiz, machine: allData.machine, start: dateStart === "" ? dayjs(new Date(Date.now())).format('YYYY-MM-DD HH:mm') : dateStart, end: dateEnd === "" ? dayjs(new Date(Date.now())).format('YYYY-MM-DD HH:mm') : dateEnd }), { auth: { username: process.env.REACT_APP_USERNAME, password: process.env.REACT_APP_SECRET_KEY } })
            .then(res => {
                if (res.status === 200) {
                    setModalOpen(false)
                    openNotification('top', t('breakdownModal.send'))
                }
                if (res.status === 201) {
                    openNotification('top', res.data, <WarningTwoTone twoToneColor="red" />)
                }
            });
    }
    const machineArray = [
        t('machines.s4p4'), t('machines.primaPower'), t('machines.primaPower2'), t('machines.s4xep4'),
        t('machines.s2'), t('machines.tc3000r'), t('machines.tc1000'), t('machines.s4xe'),
        t('machines.p2_1'), t('machines.p2_2'), t('machines.p4l'), t('machines.c120'),
        'TRUPUNCH 5000', 'TRUBEND 7030'
    ]
    return (
        <>
            {contextHolder}
            <BelirsizListModal
                modalOpenBelirsiz={modalOpenBelirsiz}
                setModalOpenBelirsiz={setModalOpenBelirsiz}
                setModifiedDataBelirsiz={setModifiedDataBelirsiz}
                modifiedDataBelirsiz={modifiedDataBelirsiz}
            />
            <UretilemeyenListModal
                modalOpenUretilemeyen={modalOpenUretilemeyen}
                setModalOpenUretilemeyen={setModalOpenUretilemeyen}
                setModifiedDataUretilemeyen={setModifiedDataUretilemeyen}
                modifiedDataUretilemeyen={modifiedDataUretilemeyen}
            />
            <Modal
                title={t('breakdownModal.title')}
                centered
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <div className='w-full flex flex-col gap-10 justify-center mt-8'>
                    <div className='flex'>
                        <label className='flex w-36 mt-1'>{t('breakdownModal.machines')} : </label>
                        <select onChange={handleChange} name="machine" className='border border-solid border-borderColor rounded-lg w-150px h-33px'>
                            <option value="" >{t('breakdownModal.select')}</option>
                            {
                                machineArray.map((item, index) => {
                                    return <option key={index} value={item}>{item}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className='flex'>
                        <label className='flex w-36 mt-1 '>{t('breakdownModal.startDateTime')} : </label>
                        <DatePicker
                            format="YYYY-MM-DD HH:mm"
                            defaultValue={dayjs()}
                            onChange={onChangeStart}
                            disabledDate={disabledDate}
                            showTime={{
                                defaultValue: dayjs('00:00:00', 'HH:mm'),
                            }}
                            onSelect={(e) => setDateStart(e)}
                            inputReadOnly={true}
                        />
                    </div>
                    <div className='flex flex-row'>
                        <label className='flex w-36 mt-1'>{t('breakdownModal.endDateTime')} : </label>
                        <DatePicker
                            format="YYYY-MM-DD HH:mm"
                            defaultValue={dayjs()}
                            onChange={(onChangeEnd)}
                            disabledDate={disabledDate}
                            showTime={{
                                defaultValue: dayjs('00:00:00', 'HH:mm'),
                            }}
                            onSelect={(e) => setDateEnd(e)}
                            inputReadOnly={true}
                        />
                        <div className='flex flex-row ml-6'>
                            <input type="checkbox" id='belirsiz' name='belirsiz' onChange={handleChange} />
                            <label className='mt-1 ml-2' htmlFor="belirsiz">{t('breakdownModal.uncertain')}</label>
                        </div>
                    </div>
                    <div className='w-full flex flex-col gap-3 justify-center mt-8'>
                        <Button onClick={uretilemeyenKod} className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base'>{t('breakdownModal.unproducibleCodes')}</Button>
                        <Button onClick={handleBelirsiz} className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base'>{t('breakdownModal.ongoingBreakdowns')}</Button>
                        <Button disabled={allData.machine === ""} onClick={handleSubmit} className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base '>{t('breakdownModal.send')}</Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default BreakdownModal
